var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Card } from '@philips-internal/oswald-ui-components/lib/components';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import HandlingOrderCardAPI from './handling-order-card-api';
import './handling-order-card.css';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
let handlingOrderCard = class handlingOrderCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { dilutionDescription, itemDescription, onClick, prescriptionDescription } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        dilutionDescription,
                        itemDescription,
                        onClick,
                        prescriptionDescription
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    renderFields() {
        const { dilutionDescription, doseQuantity, isSolution, itemDescription, prescriptionDescription, unitMeasureDoseCode, } = this.props;
        return (React.createElement("div", { className: 'c-handling-order-card__content' },
            React.createElement("span", { className: 'c-handling-order-card__item-description' }, itemDescription),
            isSolution && (React.createElement("div", { className: 'c-handling-order-card__solution-fields' },
                React.createElement("span", { className: 'c-handling-order-card__text-content' },
                    React.createElement("p", { className: 'c-handling-order-card__field-title' }, `${MessageService.translate('text.dose')}`),
                    `${doseQuantity || ''}`),
                React.createElement("span", { className: 'c-handling-order-card__text-content' },
                    React.createElement("p", { className: 'c-handling-order-card__field-title' }, `${MessageService.translate('text.unit-measure')}`),
                    `${unitMeasureDoseCode}`))),
            React.createElement("span", { className: 'c-handling-order-card__text-content' },
                React.createElement("p", { className: 'c-handling-order-card__field-title' }, `${MessageService.translate('tws.informations')}`),
                prescriptionDescription),
            dilutionDescription && (React.createElement("span", { className: 'c-handling-order-card__preparation-guidance' },
                React.createElement("p", { className: 'c-handling-order-card__field-title' }, `${MessageService.translate('text.preparation-guidance')}`),
                `${dilutionDescription}`))));
    }
    render() {
        const { doseQuantity, itemDescription, unitMeasureDoseCode, } = this.props;
        return (React.createElement(Card, { className: 'c-handling-order-card', selectionType: SelectionType.SINGLE, uuid: "53a58551-40f4-4ae8-aae5-38db5b6d4a08", width: 12, key: `${doseQuantity} + ${unitMeasureDoseCode} - ${itemDescription}` }, this.renderFields()));
    }
};
handlingOrderCard = __decorate([
    AwesomeComponent({ api: HandlingOrderCardAPI, type: ComponentType.DATA_DISPLAY })
], handlingOrderCard);
export default handlingOrderCard;
//# sourceMappingURL=handling-order-card.js.map